<template>
    <nav class="navbar navbar-expand navbar-theme p-0 pt-2">
        <img class="logo" src="@/assets/img/wildoneHis/u252.png">
        <!-- <mainMenuView class="order-1"></mainMenuView>
        <userInfoView class="order-sm-2 order-md-2 order-lx-3 order-xl-3"></userInfoView>
        <sideMenuView class="order-sm-3 order-md-3 order-lx-2 order-xl-2 me-4"></sideMenuView> -->

        <mainMenuView ></mainMenuView>
        <sideMenuView class="me-4"></sideMenuView>
        <userInfoView ></userInfoView>
    </nav>
</template>
  
<script>
import mainMenuView from '@/components/mainMenuView.vue'
import sideMenuView from '@/components/sideMenuView.vue'
import userInfoView from '@/components/userInfoView.vue'
export default {
    name:'navView',
    components: {
        mainMenuView,sideMenuView,userInfoView
    }
};
</script>
<style scoped>
.logo{
    width:93px;
}
.user-and-side{

}
@media (max-width: 767px) {
    .navbar{
        display: flex;
        flex-wrap: wrap;
    }

}
</style>